var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 341,
    viewBox: "0 0 215 341",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83043 39.7905L263.908 35.0968L268.419 285.016C268.419 285.016 167.294 290.452 161.065 186.536C155.766 97.9528 35.5969 154.394 3.831 39.8216L3.83043 39.7905Z",
    fill: "#0E58D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.013 -0.209495L287.091 -4.9032L291.601 245.016C291.601 245.016 190.477 250.452 184.248 146.536C178.948 57.9528 58.7796 114.394 27.0136 -0.178356L27.013 -0.209495Z",
    fill: "#013590"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground2);
export default __webpack_public_path__ + "static/media/background-2.f5b46b290639f7c4a6d1c5186683be72.svg";
export { ForwardRef as ReactComponent };